export enum DiscountType
{
    Percent = "percent",
    LimitedPercent = "limited-percent",
    FixedPrice = "fixed-price",
}

export enum DiscountTarget
{
    WholeBasket = "whole-basket",
    RentalItems = "rental-items",
    SaleItems = "sale-items",
    SpecificItem = "specific-item",
}

export interface RawCost
{
    Name: string;
    Code: string;
    Value: number; 
    IsVisible?: boolean;
    Description?: string;
    Target: DiscountTarget;
    Type: DiscountType;
    Limit?: number;
}
